import { Calendar, Day } from '@material-ui/pickers';
import { DayProps } from '@material-ui/pickers/views/Calendar/Day';
import React, { FC } from 'react';
import { DateRangeValue } from './DateRangePicker';
import { DateTime } from 'luxon';

const CustomTodayDay: FC<Omit<DayProps, 'current' | 'selected'>> = (props) => (
  <Day {...props} current={true} selected={false} />
);

interface FilterCalendarProps extends Omit<React.ComponentProps<typeof Calendar>, 'renderDay'> {
  selectedDate: DateRangeValue;
}

export const FilterCalendar: React.FC<FilterCalendarProps> = (props) => (
  <Calendar
    {...props}
    renderDay={(day: DateTime, selectedDate, dayInCurrentMonth, dayComponent) => {
      if (!props.selectedDate && dayInCurrentMonth && day.hasSame(DateTime.now(), 'day')) {
        return <CustomTodayDay children={day.day} />;
      }

      return dayComponent;
    }}
  />
);
